var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "lead-timeline"
  }, [_c('button', {
    staticClass: "toggle",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v(_vm._s(_vm.open ? 'Skryť priebeh' : 'Priebeh kontaktovania'))]), _vm.open ? _c('section', {
    attrs: {
      "aria-label": "História spracovania leadu"
    }
  }, [_vm.error ? _c('p', {
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm.loading ? _c('p', [_vm._v("Načítavam…")]) : [!_vm.complete ? _c('small', [_vm._v("Staršie kroky nemusia byť zaznamenané. História sa spätne nedopočítava.")]) : _vm._e(), _c('ul', _vm._l(_vm.events, function (e) {
    return _c('li', {
      key: e.id
    }, [_c('strong', [_vm._v(_vm._s(_vm.labels[e.kind] || e.value || e.kind))]), _c('span', [_vm._v(_vm._s(new Date(e.occurred_at).toLocaleString('sk-SK')) + " · " + _vm._s(e.actor))])]);
  }), 0), !_vm.events.length ? _c('p', [_vm._v("Zatiaľ bez zaznamenaných udalostí.")]) : _vm._e(), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": function click($event) {
        return _vm.record('contact_unsuccessful');
      }
    }
  }, [_vm._v("Ďalší pokus: nedovolal som sa")]), _c('button', {
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": function click($event) {
        return _vm.record('contact_connected');
      }
    }
  }, [_vm._v("Ďalší pokus: dovolal som sa")]), _c('button', {
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": function click($event) {
        return _vm.record('qualified');
      }
    }
  }, [_vm._v("Potvrdiť kvalifikovaný lead")])]), _c('small', [_vm._v("Kvalifikovaný lead: overený kontakt, relevantný záujem a dohodnutý ďalší krok. Tieto záznamy nemenia aktuálnu úlohu klienta.")])]], 2) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }